export default __webpack_public_path__ + "static/rsign-logo-2d32faa61f1ae5dcbc1102cf7bf87361.webp";